import { TrackedEvents, trackEvent } from 'analytics';
import type { AiModelEnum, QualityReportAiGravimetricComposition, QualityReportAiGravimetricSample } from 'api';
import { formatDate } from 'date';
import { useNavigate } from 'react-router-dom';
import { DataCard, ExpandableIconButton, Typography } from 'ui';
import { ImageOutlined, Insights } from 'ui/icons';

import { AiSampleBreakdown } from '../../../breakdowns';

export const AiGravimetricAnalysisDataCard = ({
  isLoading,
  sample,
  composition,
  aiModel,
  hasMedia,
}: {
  isLoading?: boolean;
  sample: QualityReportAiGravimetricSample;
  composition: QualityReportAiGravimetricComposition;
  aiModel: AiModelEnum;
  hasMedia: boolean;
}) => {
  const navigate = useNavigate();

  const handleClickMedia = () => {
    trackEvent(TrackedEvents.QUALITY_REPORT_CLICK_CATEGORY_IMAGES, {
      category: 'AI Gravimetric Analysis',
    });
    navigate('media?tab=ai_gravimetric');
  };

  return (
    <DataCard
      isLoading={isLoading}
      slotProps={{
        header: {
          action: hasMedia ? (
            <ExpandableIconButton icon={<ImageOutlined />} label="Show media" onClick={handleClickMedia} />
          ) : undefined,
          avatar: <Insights />,
          title: 'AI Gravimetric Analysis',
        },
      }}
    >
      <DataCard.Item colSpan={12}>
        <Typography
          variant="body1"
          color="textSecondary"
          sx={{
            paddingBottom: 2,
          }}
        >
          A streamlined sample process with weights estimated from Safi AI. Values are rounded to nearest 0.01 kg.
        </Typography>
      </DataCard.Item>
      <DataCard.Item title="Latest Inspection" colSpan={8}>
        {formatDate(sample?.date)}
      </DataCard.Item>
      <DataCard.Item colSpan={12}>
        <AiSampleBreakdown composition={composition} totalWeight={Number(sample?.total_weight)} variant={aiModel} />
      </DataCard.Item>
    </DataCard>
  );
};
